var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-img',{attrs:{"contain":"","max-width":"60","width":((_vm.withImg ? _vm.withImg : '60') + "px"),"src":_vm.imgSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }